export default __webpack_public_path__ + "static/budget-save-demo-0-b7947a9a885ffc35430812408805e90d.png";